import { useState,useEffect } from "react"
import { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { Stats } from '@react-three/drei'
import Experience from "./Experience.jsx"
import About from "./about.jsx";
import CalcOverlay from "./calc-overlay.jsx";
import useLocalStorage from "use-local-storage";
import { Perf } from 'r3f-perf'
const Home = ({showAboutIn}) => {

    const preference = window.matchMedia("(prefers-color-scheme : dark)").matches //Check system theme preference.
    const [isDark, setIsDark] = useLocalStorage("isDark", preference)
    const [isLite, setIsLite] = useLocalStorage("isLite", false)
    const [fIn, setFIn] = useLocalStorage("fIn", 0)
    const [fOut, setFOut] = useLocalStorage("fOut", 0)
    const [minIn, setMinIn] = useLocalStorage("minIN", 0)
    const [secIn, setSecIn] = useLocalStorage("secIN", 0)
    const [showAbout, setShowAbout] = useState(showAboutIn)
    const [wall, setWall] = useState(true)
    const [isDev, setIsDev] = useState(false)
    const [gTrack, setgTrack] = useState(false)
    const [printLiteBg, setPrintLiteBg] = useState(false);


    // One Check
    useEffect(() => {
        if(window.location.hash === '#dev'){
            setIsDev(true)            
        }else{
            setIsDev(false)
        }
      },[])

      useEffect(() => {
        if(window.location.hash === '#me'){
            setgTrack(true)            
        }else{
            setgTrack(false)
        }
      },[])
   

    // Evaluate Width to activate isLight
    useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 900) {
        console.log("Lite");
        setIsLite(true);
      } else {
        setIsLite(false);
      }
    };

  // Run once on mount
  handleResize();

  // Listen for resize
  window.addEventListener("resize", handleResize);

  // Cleanup
  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);

    useEffect(() => {
        let isIt = isLite
        setWall(isIt)
      },[isLite])

 
    return (
        <div className="full-page" data-theme={isDark?"dark":"light"}>
            <div className="mainFrame"></div>
            {
                isDev
                ?
                <CalcOverlay isDark={isDark} setIsDark={setIsDark} isLite={isLite} setIsLite={setIsLite} showAbout={showAbout} setShowAbout={setShowAbout} fIn={fIn} fOut={fOut} secIn={secIn} minIn={minIn}/>  
                :
                <CalcOverlay isDark={isDark} setIsDark={setIsDark} isLite={isLite} setIsLite={setIsLite} showAbout={showAbout} setShowAbout={setShowAbout} fIn={fIn} fOut={fOut} secIn={secIn} minIn={minIn}/> 

            }
            <div id="loadingScreen" style={{opacity:wall?1:0,}}></div>
         
            {
                 isLite
                ?
                <div className="lite-bg"></div>
                :
                <div className="exp-div"  >
                        <Suspense fallback={'-------'}>
                            <Canvas flat={true}>
                            {/* {isDev?<Stats/>:null} */}
                                {isDev?<Perf position="bottom-left"/>:null}
                                
                            <Experience isDark={isDark} showAbout={showAbout} wall={wall} setWall={setWall} />     
                            </Canvas>
                        </Suspense>
                </div>
            }        
        </div>
    );
}
 
export default Home;